import { Typography, Box, Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useIngredientContext } from "./useIngredientContext";

export const IngredientValueChain = () => {
    const { t } = useTranslation();
    const { ingredient } = useIngredientContext();

    if (!ingredient) {
        return null;
    }

    // For ingredients, we mainly show downstream (where they are used)
    // The upstream would be suppliers which is handled in the activities tab
    return (
        <Box>
            <Typography variant="h2" sx={{ mb: 3 }}>
                {t("value_chain_title", "Ingredient value chain")}
            </Typography>

            <Alert severity="info">
                {t(
                    "ingredient_value_chain_info",
                    "Value chain visualization for ingredients will be available soon. In the meantime, check the 'Information' tab to see where this ingredient is used.",
                )}
            </Alert>
        </Box>
    );
};
